import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
import { useMediaQuery, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { AddressesText } from "../../Addresses/Addresses-types";
/**
 * A dialog actions component for the add/update address form.
 * This needed to be separated out for the different modal implementations.
 * @returns
 */
export const AddUpdateAddressFormDialogActions = ({ formId, submitButtonText }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { formState } = useFormContext();
    const { isDirty, errors, isSubmitting, isValidating } = formState;
    return (_jsx(LoadingButton, Object.assign({ size: "medium", color: "primary", variant: "contained", 
        // Disable the submit button if there are errors.
        // Initial validation is performed on submission; thereafter, the disabled state will only toggle after a failed submission attempt due to form errors.
        disabled: !isDirty || !!Object.keys(errors).length, form: formId !== null && formId !== void 0 ? formId : "AddUpdateAddressForm", type: "submit", fullWidth: true, sx: { width: isMobile ? undefined : theme.spacing(20.5) }, loading: isSubmitting || isValidating }, { children: submitButtonText !== null && submitButtonText !== void 0 ? submitButtonText : AddressesText.SUBMIT })));
};
